import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { AuthenticationService, isSafeReturnUrl } from 'src/app/modules/authentication/services/authentication.service';
import { UserSetupService } from 'src/app/modules/user-profile/services/user-setup.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-auth-callback',
    templateUrl: './auth-callback.component.html',
    styleUrls: ['./auth-callback.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AuthCallbackComponent implements OnInit {

  error: boolean;
  redirectTo: any;
  private unsubscribe: Subscription[] = [];
  userProfile: any;
  isLoading$: Observable<boolean>;

  constructor(private authService: AuthenticationService, private router: Router, private route: ActivatedRoute, private userSetupService: UserSetupService) {}

  
  async ngOnInit(): Promise<void> {
    if (new URLSearchParams(this.route.snapshot.fragment || '').has('error')) {
      this.error=true; 
      return;    
      
    }

    try {
      const user = await this.authService.completeAuthentication();
      const returnUrl = user?.state?.returnUrl;
      localStorage.removeItem('pageUrl');
      localStorage.removeItem('validate');
      await this.router.navigateByUrl(isSafeReturnUrl(returnUrl) && returnUrl !== '/' ?
        returnUrl : '/dentalbridge/manage-api', { replaceUrl: true });
    } catch {
      this.error = true;
    }
  }

}
